import { MaritalStatusEntity } from '../entities/marital-status-entity';

export default class State {
  loaded = false;

  items: Array<MaritalStatusEntity> = [];
}
